import React, { useState } from "react";
import { invokeApi } from "../../../../../../bl_libs/invokeApi";
import Feadback from "./Feadback";
import {
  getMovers,
  time_convert,
} from "../../../../../../ui_libs/Functions/functions";
function Completed(props) {
  const { requestData, fetchRequestDetails } = props;
  const { truck_array } = requestData;
  const {
    id,
    final_amount,
    total_discount,
    s_time,
    request_type,
    payment_method,
    request_timeline_status,
  } = requestData.request;
  const { first_name, last_name } = requestData.get_foreman_of_company;

  const [feedback, setFeedback] = useState({
    comments: "",
    rating: 0,
  });

  const submitFeedback = () => {
    let requestObj = {
      path: "/app_api/add_feedback",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${id}`,
      rating: `${feedback.rating}`,
      comment: `${feedback.comments}`,
      tip: "",
    };
    console.log(postData);
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        fetchRequestDetails();
      } else {
      }
    });
  };
  return (
    <>
      <div className="rounded-box">
        <div className="heading-wrapper black-bg text-center">
          <h6 className="text-white">Request #{id}</h6>
        </div>
        <div className="request-left-box p-3 p-sm-4">
          <div className="row">
            <div className="col-8">
              <div className="request-staus small-font-size">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
                </svg>{" "}
                Done
              </div>
            </div>
            <div className="col-4 text-right">
              {request_type && <span className="custom-chip">Direct</span>}
            </div>
          </div>
          <div className="bid-form-wrapper pt-3">
            <div className="row small-font-size">
              <div className="col-6 text-left dark-grey-color">Start time:</div>
              <div className="col-6 text-right black-color">
                {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
                {s_time &&
                  s_time !== "8AM - 12PM Morning" &&
                  s_time !== "12PM - 5PM Evening" &&
                  s_time !== "Entire day" &&
                  `${time_convert(
                    s_time.split("-")[0].trim()
                  )} to ${time_convert(s_time.split("-")[1].trim())}`}
                {s_time &&
                  (s_time == "8AM - 12PM Morning" ||
                    s_time == "12PM - 5PM Evening" ||
                    s_time == "Entire day") &&
                  `${s_time}`}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Movers:</div>
              <div className="col-6 text-right black-color">
                {getMovers(requestData)}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Truck Name:</div>
              <div className="col-6 text-right light-red-color">
                {truck_array.map((truck, i) => {
                  return (
                    truck.name + (i === truck_array.length - 1 ? "" : ", ")
                  );
                })}
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Foreman name:
              </div>
              <div className="col-6 text-right light-red-color">
                {first_name + " " + last_name}
              </div>
            </div>
            {request_type &&
              (request_timeline_status === 6 ||
                request_timeline_status === 7) && (
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">
                    Payment Method:
                  </div>
                  <div className="col-6 text-right black-color">
                    {payment_method}
                  </div>
                </div>
              )}

            {request_type && total_discount && total_discount !== "0" && (
              <>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">Price:</div>
                  <div className="col-6 text-right black-color">
                    ${Number(final_amount) + Number(total_discount)}
                  </div>
                </div>
                <div className="row small-font-size pt-3">
                  <div className="col-6 text-left dark-grey-color">
                    Discount:
                  </div>
                  <div className="col-6 text-right light-red-color">
                    ${total_discount}
                  </div>
                </div>
              </>
            )}
            <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">
                Final Price:
              </div>
              <div className="col-6 text-right black-color">
                ${final_amount}
              </div>
            </div>
            {/* <div className="row small-font-size pt-3">
              <div className="col-6 text-left dark-grey-color">Phone #:</div>
              <div className="col-6 text-right black-color">(808) 555-0111</div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-4 text-left dark-grey-color">Email:</div>
              <div className="col-8 text-right black-color">
                <a
                  href="mailto:companyname@example.com"
                  className="light-red-color"
                >
                  companyname@example.com
                </a>
              </div>
            </div>
            <div className="row small-font-size pt-3">
              <div className="col-4 text-left dark-grey-color">Address:</div>
              <div className="col-8 text-right black-color">
                LA 12345, Mersedes-Benz, 2015, Van, 15 ft
              </div>
            </div> */}
            <div className="row pt-3 pb-3">
              <div className="col-12">
                <button
                  className="custom-buton custom-buton-large w-100"
                  data-toggle="modal"
                  data-target="#feedback"
                >
                  Leave Feedback
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Feadback
        requestData={requestData}
        feedback={feedback}
        setFeedback={setFeedback}
        submitFeedback={submitFeedback}
      />
    </>
  );
}

export default Completed;
